export default "__VITE_ASSET__DTOqxLAN__"